import type { ColumnLayout } from '@/shared/store/column-layout.store.ts'

/**
 * Returns a copy of the layout with any column IDs not present in `validIds`
 * removed from `columnOrder`, `hiddenColumns`, and `columnWidths`.
 */
export function pruneColumnLayout(
  layout: ColumnLayout,
  validIds: Set<string>,
): ColumnLayout {
  return {
    columnOrder: layout.columnOrder.filter((id) => validIds.has(id)),
    hiddenColumns: layout.hiddenColumns.filter((id) => validIds.has(id)),
    columnWidths: Object.fromEntries(
      Object.entries(layout.columnWidths).filter(([id]) => validIds.has(id)),
    ),
  }
}
